<template>
  <v-container class="pa-0" fluid ref="vendor-hall-container">
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 1920 1440"
      style="enable-background: new 0 0 1920 1440"
      xml:space="preserve"
    >
      <g id="Background_xA0_Image_1_">
        <image
          style="overflow: visible"
          width="1920"
          height="1440"
          id="Background_xA0_Image"
          :xlink:href="main_img"
        ></image>
      </g>
      <g id="Rectangle_1_2_" class="st0 cursor_pointer" @click="openLink(1)">
        <defs>
          <rect id="SVGID_1_" y="396" class="st0" width="720" height="450" />
        </defs>
        <clipPath id="SVGID_2_">
          <use xlink:href="#SVGID_1_" style="overflow: visible" />
        </clipPath>

        <image
          style="overflow: visible; clip-path: url(#SVGID_2_)"
          width="1920"
          height="1440"
          id="Rectangle_1_xA0_Image"
          :xlink:href="image1"
        ></image>
      </g>
      <g
        id="Rectangle_1_copy_2_"
        class="st0"
      >
        <defs>
          <rect
            id="SVGID_3_"
            x="1200"
            y="396"
            class="st0"
            width="720"
            height="450"
          />
        </defs>
        <clipPath id="SVGID_4_">
          <use xlink:href="#SVGID_3_" style="overflow: visible" />
        </clipPath>

        <image
          style="overflow: visible; clip-path: url(#SVGID_4_)"
          width="1920"
          height="1440"
          id="Rectangle_1_copy_xA0_Image"
          :xlink:href="image1"
        ></image>
      </g>
    </svg>
  </v-container>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {
    main_img() {
      return process.env.VUE_APP_ASSETS + "BA77B15C.jpg";
    },
    image1() {
      return process.env.VUE_APP_ASSETS + "ballroom.jpg";
    },
  },
  methods: {
    openLink(room_id) {
      this.$router.push("/vendor-hall/" + room_id);
      console.log(room_id);
    },
  },
  mounted() {
    this.$vuetify.goTo(this.$refs["vendor-hall-container"], {
      offset: -200,
    });
  },
};
</script>
<style type="text/css">
.st0 {
  opacity: 0.502;
}
</style>